var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.closed)?_c('v-alert',{class:_vm.alertClass,attrs:{"type":"info","text":"","dense":""}},[_vm._v(_vm._s(_vm.$modules.message(_vm.module)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }